import { useQuery } from "@tanstack/react-query";
import { expoPaymentWorkflowsApi } from "../services/expoPaymentWorkflowsApi";

export const useExpoPaymentApprovalBatches = (expoId?: string) =>
  useQuery({
    queryKey: ["expo-payment-batches", expoId],
    queryFn: () => expoPaymentWorkflowsApi.batches(expoId!),
    enabled: !!expoId,
  });

export const useExpoCashHandovers = (expoId?: string) =>
  useQuery({
    queryKey: ["expo-cash-handovers", expoId],
    queryFn: () => expoPaymentWorkflowsApi.cashHandovers(expoId!),
    enabled: !!expoId,
  });

export const useExpoPaymentVariances = (expoId?: string) =>
  useQuery({
    queryKey: ["expo-payment-variances", expoId],
    queryFn: () => expoPaymentWorkflowsApi.variances(expoId!),
    enabled: !!expoId,
  });
